import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  withStyles, Container, CssBaseline, AppBar, Toolbar, Typography,
} from '@material-ui/core';
import { bindActionCreators } from 'redux';
import { withRouter, Redirect } from 'react-router-dom';
import GoogleButton from 'react-google-button';
import styles from '../assets/styles/jss/Home';
import Actions from '../actions';

import { signIn, setToken } from '../firebase/firebase';

class SignIn extends Component {
  // componentDidMount() {
  //   this.props.signIn();
  // }

  signin = () => {
    signIn()
      .then((data) => {
        setToken(data.idToken);
        this.props.signIn(data)
        // eslint-disable-next-line consistent-return
          .then(() => {
            if (this.props.auth.isAuthenticated) {
              return (<Redirect to="/" />);
            }
          });
        // ...
      })
      .catch((error) => {
      // Handle Errors here.
        const errorCode = error.code;
        const errorMessage = error.message;
        // The email of the user's account used.
        const email = error.email;
        // The firebase.auth.AuthCredential type that was used.
        const credential = error.credential;
        console.log(errorCode, errorMessage, email, credential);
      // ...
      });
  }

  render() {
    if (this.props.auth.isAuthenticated || localStorage.token) {
      return <Redirect to="/" />;
    }
    return (
      <div>
        <CssBaseline />
        <AppBar position="static">
          <Toolbar style={{ background: '#583c5c' }}>
            {/* <IconButton edge="start" color="inherit" aria-label="menu">
            <MenuIcon />
          </IconButton> */}
            <Typography variant="h6" noWrap>
              Stamurai Dashboard
            </Typography>
          </Toolbar>
        </AppBar>
        <Container>
          <div style={{
            display: 'flex', justifyContent: 'center', alignItems: 'center', height: '90vh',
          }}
          >
            <GoogleButton onClick={this.signin} />
          </div>
        </Container>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(SignIn)));
